const OUTER_VAR = /^var\(\s*(--[\w-]+)\s*(?:,\s*([\s\S]*))?\)$/;

// For consumers that cannot read custom properties, such as Stripe Elements in its iframe.
export const resolveCssValue = (value: string, element?: Element): string => {
  const outerVar = OUTER_VAR.exec(value.trim());
  if (!outerVar) return value.trim();

  const [, name, fallback = ''] = outerVar;
  const declared =
    typeof window === 'undefined'
      ? ''
      : getComputedStyle(element ?? document.documentElement)
          .getPropertyValue(name)
          .trim();

  return declared || resolveCssValue(fallback, element);
};
